<template>
  <div
    :class="`
      statistics-beam
      font-weight-light
      ${color}
      ${color && color.includes('lighten') || color && color.includes('darken')? '':'lighten-1'}
      ${text_color}--text
      `"
    :style="`
      height: calc(${max_value !== 0? `${(value / max_value)} * (100% - (${takt_sum_height?takt_sum_height:'25px'} * ${no_zoom?1:'var(--taktplan_zoom)'})) ${margin_top?`- 1px`:''}`:'0px'});
      ${color === '' && value !== 0? 'border: solid 1px var(--v-primary-base);':'color: black;'}
      ${width?`width: ${width};`:''}
      ${no_zoom?`font-size: 16px;`:''}
      ${margin_top?`margin-top: ${margin_top}`:''}
    `"
    >
    <TTooltip v-if="showIcon(icon)" class="tooltip-content" :value="tooltip ? tooltip : '' ">
      <TIcon :name="icon" color="black" small class="statistics-beam-icon" />
      <div v-if="!no_text">{{value}}</div>
      <slot/>
    </TTooltip>

    <TTooltip v-else class="tooltip-content" :value="tooltip ? tooltip : '' ">
      <div v-if="!no_text">{{value}}</div>
      <slot/>
    </TTooltip>
  </div>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
export default {
  components: {
    TIcon
  },
  props: [
    'value',
    'color',
    'text_color',
    'max_value',
    'width',
    'no_zoom',
    'no_text',
    'takt_sum_height',
    'margin_top',
    'wps_count',
    'tooltip',
    'icon'
  ],
  data: () => ({
  }),
  methods: {
    showIcon(icon){
      if (icon) {
        if (
          icon !== 'panorama_fish_eye' &&
          icon !== 'checkbox-radial-empty' &&
          icon !== 'none'
        ) {
          return true;
        }
      }
      return false;
    }
  }
}
</script>
<style>
  .statistics-beam {
    display: flex;
    width: 50%;
    user-select: none;
    text-align: center;
    overflow: hidden;
    font-size: calc(16px * var(--taktplan_zoom));
    justify-content: center;
    align-items: flex-start;
    transition: width ease-in-out 0.2s, height 300ms ease-in-out, width ease-in-out 0.2s;
  }
  .statistics-beam-icon {
    margin-top: 4px;
  }
  .tooltip-content {
    height: 100%;
    width: 100%;
    display: flex;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    text-align: center;
    overflow: hidden;
    font-size: calc(16px * var(--taktplan_zoom));
    justify-content: center;
    align-items: flex-start;
  }
</style>
